import VueQrcode from 'vue-qrcode';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('VueQrcode', VueQrcode)
})
